import { SxProps } from '@mui/material'

interface PhoneNumberStyles {
  startAdornment: SxProps
}

export const phoneNumberStyles: PhoneNumberStyles = {
  startAdornment: { width: 'auto', height: 'auto', typography: 'textMd' },
}
